import { Component, ViewEncapsulation, QueryList, ElementRef, ViewChildren, AfterViewInit, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { HelpIndex } from '../../../models/enums';
import { ViewType } from '../../../models/view';
import { XMLService } from '../../../services/xml/xml.service';
import { isUndefined } from '../../../models/utils';
import { CommonService } from '../../../services/common/common.service';

@Component({
    standalone: false,
    selector: 'res-workbasket-task-details-modal',
    templateUrl: './workbasket-task-details-modal.component.html',
    styleUrls: ['./workbasket-task-details-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class WorkbasketTaskDetailsModalComponent extends BaseModalComponent implements OnInit, AfterViewInit {
    @ViewChildren('valueField') valueFieldList: QueryList<ElementRef>;

    modalTitle = 'Task Details';
    modalAutomationId = 'workbasket-task-details';
    secondaryButtonLabel = 'Close';
    modalHelpIndex = HelpIndex.work_basket_details_dlg;
    modalClass = 'workbasket-task-details-modal';
    viewType: ViewType;
    taskDetails = [];

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private xmlService: XMLService,
        private commonService: CommonService
    ) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        const allTaskDetails = this.modalData.taskDetails;
        this.viewType = this.modalData.viewType;
        const isSearch = (this.viewType === ViewType.CORPUS_RESULT || this.viewType === ViewType.CORPUS_SET_RESULT ||
            this.viewType === ViewType.WORKING_SET_RESULT);
        allTaskDetails.forEach(status => {
            const statusText = status.name.trim();
            status.currentStatusAutoId = statusText.replace(/\s+/g, '-').toLowerCase();
            status.data.forEach(data => {
                const dataText = data.name.trim();
                if (isSearch && statusText === 'Search Details' && dataText === 'Description:') {
                    const queryParts = this.xmlService.extractQuery(data.value);
                    data.value = (queryParts[2] ? queryParts[2] : '') +
                        (!this.commonService.currentBrowserIsIE ? (window as any).hljs?.highlightAuto(queryParts[0]).value : queryParts[0]);
                    if (!isUndefined(queryParts[1])) {
                        data.value += queryParts[1];
                    }
                }
                if (data.value === 'CaseData') {
                    data.value = 'Project Data';
                }
                data.dataAutoId = dataText.replace(/\s+/g, '-').toLowerCase();
            });
        });
        this.taskDetails = allTaskDetails;
    }

    ngAfterViewInit(): void {
        this.valueFieldList.changes.subscribe((elements: QueryList<ElementRef>) => {
            if (elements.length > 0) {
                const valueFields = elements.toArray();
                let valueFieldIndex = 0;
                this.modalData.taskDetails.forEach(status => {
                    status.data.forEach(data => {
                        valueFields[valueFieldIndex++].nativeElement.innerHTML = data.value;
                    });
                });
            }
        });
    }
}
